import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App, applyTerrainProfilePersistencePreference } from './App';
import { CookieConsent } from './CookieConsent';
import { consentAllows, readCookieConsent } from './cookie-consent';
import { setYandexMetrikaEnabled } from './yandex-metrika';

const root = document.querySelector<HTMLDivElement>('#root');
if (!root) throw new Error('Root element is missing');

setYandexMetrikaEnabled(consentAllows(readCookieConsent(document.cookie), 'analytics'));

createRoot(root).render(
  <StrictMode>
    <App />
    <CookieConsent
      onStoragePreferenceChange={applyTerrainProfilePersistencePreference}
      onAnalyticsPreferenceChange={setYandexMetrikaEnabled}
    />
  </StrictMode>,
);
